import Router from 'next/router';

import Debug from 'debug';

const debug = Debug('rs:lib/utils/redirect');

const redirect = ({ res, url, as = url, replace = false }) => {
  debug('redirecting to url: %s, as: %s, replace: %s', url, as, replace);

  if (res) {
    res.redirect(302, url);
    return;
  }

  if (replace) {
    Router.replace(url, as);
  } else {
    Router.push(url, as);
  }
};

export default redirect;
